export function removeHTMLTags(str) {
    return str.replace(/<\/?[^>]+(>|$)/g, "");
}
export function getAllYearsBetweenTwoYears(year1, year2) {
    var years = [year1.toString()];
    while (year1 <= year2) {
        years.push((year1++).toString());
    }
    return years;
}
